export const staticColumns = [
  "All Requirements",
  "Associated",
  "Submitted to Sales",
  "Interview Scheduled",
  "Selected",
  "New Requirements",
  "No Submission",
  "Submitted to Client",
  "Interview Happened",
  "Rejected",
  "Active Requirements",
  "Withdrawn",
];

export const FILTER_LABELS = {
  dateRange: "Date Range",
  salesPerson: "Sales Person",
  recruiter: "Recruiter",
  client: "Client",
  country: "Country",
  currentStage: "Current Stage",
};

const NORMAL = "normal";
const JSONB = "jsonb";

export const CANDIDATE_STATIC_INITIAL_OPTIONS = [
  {
    sortValue: "job.job_submission_data.accountName",
    label: "Client Name",
    value: "job.jobSubmissionData.accountName",
    sort: true,
    expand: true,
    sortType: JSONB,
  },
  {
    sortValue: "job.job_submission_data.jobTitle",
    label: "Job Title",
    value: "job.jobSubmissionData.jobTitle",
    sort: true,
    expand: true,
    sortType: JSONB,
  },
  {
    sortValue: "job.job_submission_data.jobId",
    label: "Pulse Job ID",
    value: "job.jobSubmissionData.jobId",
    sort: true,
    expand: true,
    sortType: JSONB,
  },
  {
    sortValue: "job.job_submission_data.accountOwner",
    label: "Sales Person",
    value: "job.jobSubmissionData.accountOwner",
    sort: true,
    expand: true,
    sortType: JSONB,
  },
  {
    sortValue: "users.first_name",
    label: "Recruiter",
    value: "createdByName",
    sort: true,
    expand: true,
    sortType: NORMAL,
  },
];

export const CANDIDATE_STATIC_MANDATORY_OPTIONS = [];

export const INITAL_CANDIDATE_STATIC_REPORT_FILTER = [
  {
    label: FILTER_LABELS.dateRange,
    field: "job_timeline.created_at",
    filterType: "custom",
  },
  {
    label: FILTER_LABELS.salesPerson,
    field: "job.job_submission_data.accountOwner",
    filterType: "custom",
  },
  {
    label: "Recruiter",
    field: "users.first_name + users.last_name",
    filterType: "custom",
  },
  {
    label: "Client",
    field: "job.job_submission_data.accountName",
    filterType: "custom",
  },
  {
    label: "Country",
    field: "job.job_submission_data.country",
    filterType: "custom",
  },
  { label: "Current Stage", field: "currentStage", filterType: "custom" },
];
